import { useTranslation } from "react-i18next";
import { LegalPageLayout } from "./LegalPageLayout.tsx";
import { PrivacyBg } from "./content/PrivacyBg.tsx";
import { PrivacyEn } from "./content/PrivacyEn.tsx";

const contents = { bg: PrivacyBg, en: PrivacyEn } as const;

export const PrivacyPage = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language.split("-")[0] === "bg" ? "bg" : "en";
  const Content = contents[lang];
  return (
    <LegalPageLayout>
      <Content />
    </LegalPageLayout>
  );
};
